import { TextEmbeddingItem } from '@shared/models/report.model';

export class SentenceSimilarity {
  static parseEmbedding(embedding: string, index: number): Float32Array {
    if (!embedding) {
      return null;
    }
    const floatArr: Float32Array = new Float32Array(Uint8Array.from(atob(embedding), (c) => c.charCodeAt(0)).buffer);
    return floatArr.slice(384 * index, 384 * (index + 1));
  }

  static compareVectors(traits: TextEmbeddingItem[], themes: Float32Array[]): number[] {
    const results: number[] = [];

    for (let i = 0; i < traits.length; i++) {
      const rawTrait: TextEmbeddingItem = traits[i];
      const trait: Float32Array = this.parseEmbedding(rawTrait?.embedding, rawTrait?.embeddingIndex);

      let maxSimilarity: number = -Infinity;
      let mostSimilarIndex: number = -1;

      for (let j = 0; j < themes.length; j++) {
        const theme: Float32Array = themes[j];
        const similarity: number =
          trait?.length > 0 && theme?.length > 0 ? this.cosineSimilarity(trait, theme) : -Infinity;

        if (similarity > maxSimilarity) {
          maxSimilarity = similarity;
          mostSimilarIndex = j;
        }
      }

      results.push(mostSimilarIndex);
    }

    return results;
  }

  static cosineSimilarity(vec1: Float32Array, vec2: Float32Array): number {
    if (vec1.length !== vec2.length) {
      throw new Error('Vectors must have the same dimensions');
    }

    let dotProduct: number = 0;
    let mag1: number = 0;
    let mag2: number = 0;

    for (let i = 0; i < vec1.length; i++) {
      dotProduct += vec1[i] * vec2[i];
      mag1 += vec1[i] * vec1[i];
      mag2 += vec2[i] * vec2[i];
    }

    mag1 = Math.sqrt(mag1);
    mag2 = Math.sqrt(mag2);

    if (mag1 === 0 || mag2 === 0) {
      return 0;
    }

    return dotProduct / (mag1 * mag2);
  }
}
